import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import banner1 from "../assets/banner1.png";
import banner2 from "../assets/banner2.png";
import banner3 from "../assets/banner3.png";
import banner4 from "../assets/banner4.png";
import logo from "../assets/logo.png";
import { 
  FaArrowRight, 
  FaPhoneAlt
} from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";

export default function HomeBanner1() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);
  const [bgIndex, setBgIndex] = useState(0);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const banners = [banner4, banner3, banner1, banner2, ];

  useEffect(() => {
    AOS.init({ duration: 1000, once: true, offset: 50, easing: "ease-out-cubic" });
    setReady(true);
  }, []);

  useEffect(() => {
    if (!ready) return undefined;
    const interval = setInterval(() => {
      setBgIndex((prev) => (prev + 1) % banners.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [ready, banners.length]);

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({
        x: (e.clientX / window.innerWidth - 0.5) * 20,
        y: (e.clientY / window.innerHeight - 0.5) * 20,
      });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  if (!ready) {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }

  return (
    <>
      {/* Modern CSS Styles */}
      <style>{`
        /* Hero Section Base */
        .hero-modern {
          position: relative;
          min-height: 100vh;
          display: flex;
          align-items: center;
          overflow: hidden;
          background: #0a6345;
        }

        /* Animated Gradient Background */
        .hero-gradient-bg {
          position: absolute;
          inset: 0;
          background: 
            radial-gradient(ellipse at 20% 20%, rgba(7, 121, 58, 0.15) 0%, transparent 50%),
            radial-gradient(ellipse at 80% 80%, rgba(14, 110, 65, 0.1) 0%, transparent 50%),
            radial-gradient(ellipse at 50% 50%, rgba(9, 97, 38, 0.08) 0%, transparent 60%);
          z-index: 0;
          animation: gradientShift 15s ease infinite;
        }
        @keyframes gradientShift {
          0%, 100% { opacity: 0.7; }
          50% { opacity: 1; }
        }

        /* Background Image Slider */
        .hero-bg-slider {
          position: absolute;
          inset: 0;
          z-index: 1;
        }
        .hero-bg-slide {
          position: absolute;
          inset: 0;
          background-size: cover;
          background-position: center;
          opacity: 0;
          transition: opacity 1.5s ease-in-out;
        }
        .hero-bg-slide.active {
          opacity: 0.4;
        }
        .hero-bg-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(
            135deg,
            rgba(10, 14, 26, 0.95) 0%,
            rgba(10, 14, 26, 0.75) 50%,
            rgba(10, 14, 26, 0.6) 100%
          );
        }

        /* Floating Geometric Shapes */
        .hero-shape {
          position: absolute;
          border-radius: 50%;
          filter: blur(60px);
          opacity: 0.5;
          z-index: 1;
          pointer-events: none;
          transition: transform 0.3s ease;
        }
        .hero-shape.one {
          width: 400px;
          height: 400px;
          background: linear-gradient(135deg, #0d6efd, #6ea8fe);
          top: -100px;
          right: -100px;
        }
        .hero-shape.two {
          width: 300px;
          height: 300px;
          background: linear-gradient(135deg, #198754, #4ade80);
          bottom: -80px;
          left: -80px;
        }
        .hero-shape.three {
          width: 200px;
          height: 200px;
          background: linear-gradient(135deg, #6f42c1, #a78bfa);
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          opacity: 0.3;
        }

        /* Grid Pattern Overlay */
        .hero-grid-pattern {
          position: absolute;
          inset: 0;
          background-image: 
            linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px);
          background-size: 60px 60px;
          z-index: 1;
          pointer-events: none;
        }

        /* Content Container */
        .hero-content {
          position: relative;
          z-index: 1;
          width: 100%;
          padding: 4rem 2rem 3rem;
        }

        /* Logo Badge */
        .hero-logo-badge {
          display: inline-flex;
          align-items: center;
          gap: 12px;
          background: rgba(255,255,255,.15);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.15);
          padding: 10px 22px;
          border-radius: 10px;
          margin-bottom: 2rem;
          transition: all 0.3s ease;
        }
        .hero-logo-badge:hover {
          background: rgba(255, 255, 255, 0.12);
          border-color: rgba(255, 255, 255, 0.25);
          transform: translateY(-2px);
        }
        .hero-logo-badge img {
          width: 42px;
          height: 42px;
          object-fit: contain;
        }
        .hero-logo-badge span {
          color: #fff;
          font-weight: 600;
          font-size: 0.95rem;
          letter-spacing: 0.5px;
        }

        /* Main Headline */
        .hero-headline {
          font-size: clamp(2.5rem, 7vw, 4.5rem);
          font-weight: 800;
          line-height: 1.05;
          margin-bottom: 1.5rem;
          max-width: 900px;
        }
        .hero-headline-gradient {
          background: linear-gradient(135deg, #ffffff 0%, #6ea8fe 50%, #4ade80 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        /* Subtitle */
        .hero-subtitle {
          font-size: clamp(1.1rem, 2vw, 1.35rem);
          color: rgba(255, 255, 255, 0.85);
          line-height: 1.7;
          max-width: 650px;
          margin-bottom: 2.5rem;
          font-weight: 400;
        }

        /* CTA Buttons Group */
        .hero-cta-group {
          display: flex;
          flex-wrap: wrap;
          gap: 1rem;
          margin-bottom: 3rem;
        }
        .hero-btn-primary {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          background: linear-gradient(135deg, #fde50d, #807518);
          color: #fff;
          padding: 16px 32px;
          border-radius: 14px;
          font-weight: 600;
          font-size: 1.05rem;
          border: none;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
          box-shadow: 0 10px 40px rgba(22, 23, 24, 0.4);
        }
        .hero-btn-primary:hover {
          transform: translateY(-3px);
          box-shadow: 0 15px 50px rgba(13, 110, 253, 0.55);
        }
        .hero-btn-secondary {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          background: rgba(255, 255, 255, 0.08);
          backdrop-filter: blur(10px);
          color: #fff;
          padding: 16px 32px;
          border-radius: 14px;
          font-weight: 600;
          font-size: 1.05rem;
          border: 1px solid rgba(255, 255, 255, 0.2);
          cursor: pointer;
          transition: all 0.3s ease;
        }
        .hero-btn-secondary:hover {
          background: rgba(255, 255, 255, 0.15);
          border-color: rgba(255, 255, 255, 0.35);
          transform: translateY(-3px);
        }

        /* Feature Pills */
        .hero-features {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          margin-bottom: 3rem;
        }
        .feature-pill {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: rgba(255, 255, 255, 0.06);
          backdrop-filter: blur(12px);
          border: 1px solid rgba(255, 255, 255, 0.12);
          color: rgba(255, 255, 255, 0.9);
          padding: 10px 18px;
          border-radius: 12px;
          font-size: 0.9rem;
          font-weight: 500;
          transition: all 0.25s ease;
        }
        .feature-pill:hover {
          background: rgba(255, 255, 255, 0.12);
          border-color: rgba(255, 255, 255, 0.25);
          transform: translateY(-2px);
        }
        .feature-pill svg {
          color: #4ade80;
          font-size: 1rem;
        }

        /* Stats Row */
        .hero-stats {
          display: flex;
          flex-wrap: wrap;
          gap: 3rem;
          padding-top: 2.5rem;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
        }
        .stat-box {
          text-align: left;
        }
        .stat-number {
          font-size: 2.5rem;
          font-weight: 800;
          background: linear-gradient(135deg, #fff, #6ea8fe);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          line-height: 1;
          display: block;
          margin-bottom: 0.5rem;
        }
        .stat-label {
          color: rgba(255, 255, 255, 0.7);
          font-size: 0.95rem;
          font-weight: 500;
        }

        /* Scroll Indicator */
        .hero-scroll-indicator {
          position: absolute;
          bottom: 40px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          color: rgba(255, 255, 255, 0.6);
          font-size: 0.85rem;
          z-index: 1;
          animation: scrollBounce 2.5s infinite;
        }
        @keyframes scrollBounce {
          0%, 20%, 50%, 80%, 100% { transform: translateX(-50%) translateY(0); }
          40% { transform: translateX(-50%) translateY(-12px); }
          60% { transform: translateX(-50%) translateY(-6px); }
        }
        .hero-scroll-indicator svg {
          font-size: 1.5rem;
        }

        /* Responsive */
        @media (max-width: 991px) {
          .hero-content { padding: 3rem 1.5rem 2.5rem; }
          .hero-stats { gap: 2rem; }
          .stat-number { font-size: 2rem; }
        }
        @media (max-width: 575px) {
          .hero-content { padding: 2.5rem 1rem 2rem; }
          .hero-cta-group { flex-direction: column; }
          .hero-btn-primary, .hero-btn-secondary { width: 100%; justify-content: center; }
          .hero-stats { gap: 1.5rem; }
          .stat-number { font-size: 1.75rem; }
          .hero-scroll-indicator { bottom: 30px; }
        }
      `}</style>

      <section className="hero-modern">
        {/* Gradient Background */}
        <div className="hero-gradient-bg" />

        {/* Background Image Slider */}
        <div className="hero-bg-slider">
          {banners.map((banner, index) => (
            <div
              key={banner}
              className={`hero-bg-slide ${bgIndex === index ? "active" : ""}`}
              style={{ backgroundImage: `url(${banner})` }}
            />
          ))}
          <div className="hero-bg-overlay" />
        </div>

        {/* Floating Shapes (Parallax) */}
        <div 
          className="hero-shape one"
          style={{ transform: `translate(${mousePosition.x}px, ${mousePosition.y}px)` }}
        />
        <div 
          className="hero-shape two"
          style={{ transform: `translate(${-mousePosition.x}px, ${-mousePosition.y}px)` }}
        />
        <div className="hero-shape three" />

        {/* Grid Pattern */}
        <div className="hero-grid-pattern" />

        {/* Main Content */}
        <div className="container hero-content">
          <div className="row align-items-center">
            <div className="col-lg-10 col-xl-9">
             
              {/* Headline */}
              <h1 
                className="hero-headline text-secondary font-bold"
                data-aos="fade-up"
                data-aos-delay="150"
                data-aos-duration="900"
              >
                Building Tanzania's Future with{" "}
                <span className="hero-headline-gradient">
                  Engineering Excellence
                </span>
              </h1>

              {/* Subtitle */}
              <p 
                className="hero-subtitle"
                data-aos="fade-up"
                data-aos-delay="250"
                data-aos-duration="900"
              >
                Certified electrical, civil, and industrial engineering solutions 
                delivered with precision, safety, and innovation across Tanzania.
              </p>

              {/* CTA Buttons */}
              <div 
                className="hero-cta-group"
                data-aos="fade-up"
                data-aos-delay="450"
                data-aos-duration="800"
              >
                <button
                  className="hero-btn-primary"
                  onClick={() => appContext.navTo({ item: "services" })}
                >
                  Explore Services <FaArrowRight />
                </button>
                <a
                  href="tel:+255712345678"
                  className="hero-btn-secondary btn"
                >
                  <FaPhoneAlt /> Get a Quote
                </a>
              </div>

            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="hero-scroll-indicator">
          <span>Scroll to explore</span>
          <FaArrowRight style={{ transform: "rotate(90deg)" }} />
        </div>
      </section>
    </>
  );
}